import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_StudentMeals } from "../shared/data.service";

@Component({
	selector: "app-add-meal",
	templateUrl: "./add-meal.component.html",
	styleUrls: ["./add-meal.component.css"],
})
export class AddMealComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private MealsService: DataService_StudentMeals
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;

		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.StudentID = this.SelectedPerson.DesignatorID;
		this.StudentName = this.SelectedPerson.PersonName;

		this.loadStudentInfo();
	}

	///////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////

	user: any;
	SelectedPerson: any;
	MealData: any;

	StudentID: any = "";
	StudentName: any = "";
	MealSubsidyDesc: any = "";
	CurrentBalance: any = 0;
	CurrentBalanceDesc: any = "";

	MealPriceBeforeDesc: any = "";
	MealPriceAfterDesc: any = "";

	NewBalance: any = "";

	Meal: any;
	lstMeal: any = [];

	MealSubsidyType: any;
	lstMealSubsidyType: any = [];

	MealDate: Date = new Date();
	MealTime: Date = new Date();
	Comments: any = "";

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////
	loadStudentInfo() {
		var result = this.MealsService.StudentAddMealInfoSelect(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				// console.log(response);

				var data: any = response;

				if (data.length > 0) {
					this.MealData = data[0];

					this.CurrentBalance = this.MealData.CurrentBalance;
					this.CurrentBalanceDesc = this.MealData.CurrentBalanceDesc;
					this.MealSubsidyDesc = this.MealData.MealSubsidyTypeDesc;
				} else {
					this.CurrentBalance = 0;
					this.CurrentBalanceDesc = "$0.00";
					this.MealSubsidyDesc = "N/A";
				}

				this.loadMealSubsidies();
			},
			(error) => {}
		);
	}

	loadMealSubsidies() {
		var result = this.MealsService.MealSubsidyTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstMealSubsidyType = response;
				this.MealSubsidyType = this.lstMealSubsidyType[0];

				if (this.MealData.MealSubsidyTypeID != -1) {
					for (var z = 0; z < this.lstMealSubsidyType.length; z++) {
						var next = this.lstMealSubsidyType[z];

						if (next.MealSubsidyTypeID == this.MealData.MealSubsidyTypeID) {
							this.MealSubsidyType = next;
							break;
						}
					}
				}

				this.loadMeals();
			},
			(error) => {}
		);
	}

	loadMeals() {
		var result = this.MealsService.MealInfoSelectList(this.SelectedPerson.SchoolID);
		result.subscribe(
			(response) => {
				this.lstMeal = response;
				this.Meal = this.lstMeal[0];
				this.MealPriceBeforeDesc = this.Meal.MealPriceDesc;

				this.MealPriceAfterDesc = "$" + (this.Meal.MealPrice - (this.Meal.MealPrice * this.MealSubsidyType.MealSubsidyPct) / 100).toFixed(2);

				// console.log(this.Meal);
				// console.log(this.Meal.MealPrice);
				// console.log(this.MealSubsidyType);
				// console.log(this.MealSubsidyType.MealSubsidyTypePct);
			},
			(error) => {}
		);
	}

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////
	onAdd() {}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////
	onMealChange(val) {
		this.Meal = val;
	}

	onMealSubsidyTypeChange(val) {}
	///////////////////////////////////////////////////////////////////////////
}
